import createStyledEnhancer from "../helpers/createStyledEnhancer";
import { composeEnhancers } from "../helpers";
export var background = createStyledEnhancer({
  name: "background",
  alias: ["bg"],
  keys: ["color", "palette"],
  workLikeGetByPathOnKeys: ["color", "palette", "palettes"]
});
var backgroundAttachment = createStyledEnhancer({
  name: "backgroundAttachment"
});
var backgroundClip = createStyledEnhancer({
  name: "backgroundClip"
});
export var backgroundColor = createStyledEnhancer({
  name: "backgroundColor",
  keys: ["color", "palette"],
  workLikeGetByPathOnKeys: ["color", "palette", "palettes"]
});
var backgroundImage = createStyledEnhancer({
  name: "backgroundImage"
});
var backgroundOrigin = createStyledEnhancer({
  name: "backgroundOrigin"
});
var backgroundPosition = createStyledEnhancer({
  name: "backgroundPosition"
});
var backgroundRepeat = createStyledEnhancer({
  name: "backgroundRepeat"
});
var backgroundSize = createStyledEnhancer({
  name: "backgroundSize"
});
export var color = createStyledEnhancer({
  name: "color",
  keys: ["color", "palette"],
  workLikeGetByPathOnKeys: ["color", "palette", "palettes"]
});
export var colors = composeEnhancers(background, backgroundAttachment, backgroundClip, backgroundColor, backgroundImage, backgroundOrigin, backgroundPosition, backgroundRepeat, backgroundSize, color);
/** Пропсы, которые стайлед будет пытаться преобразовать в атрибуты. Нужны для фильтрации */

export var colorPropsNoForward = ["color"];